import React from 'react';
import { Tooltip, Fab } from '@material-ui/core';
import { FindInPage } from '@material-ui/icons';
import { parseURL } from '../sc-utilities';

const GoToCard = props => {
  const { setRedirectOptions } = props;
  let searchParams = parseURL(window.location.search) ? parseURL(window.location.search) : {};

  const getPath = () => {
    if (searchParams.Type) {
      switch (searchParams.Type) {
        case 'Order':
          return { name: 'Order', path: `/order/details?Order=${searchParams.OrderID}` };
        default:
          return { name: 'Page', path: `/dashboard/asset-overview` };
      }
    }

    switch (searchParams.ProductType) {
      case 'PCProduct':
        return { name: 'PC Product', path: `/pc-product/details?productID=${searchParams.ProductID}&type=PCProduct` };
      case 'MobileProduct':
        return { name: 'Mobile Product', path: `/mobile-product/details?productID=${searchParams.ProductID}&type=MobileProduct` };
      case 'StorageProduct':
        return { name: 'Storage Product', path: `/storage-product/details?productID=${searchParams.ProductID}&type=StorageProduct` };
      default:
        return { name: 'Page', path: `/dashboard/asset-overview` };
    }
  }

  return (<Tooltip title={`Go to ${getPath().name}`}>
    <Fab color="primary" style={{ borderRadius: '1px' }}
      onClick={() => setRedirectOptions({ path: getPath().path })}>
      <FindInPage />
    </Fab>
  </Tooltip >
  );
};



export default GoToCard;
